<!-- 进度条 -->
<template>
  <div class="zlr-progress"
       ref="progress"
       :class="[isStick? 'zlr-progress-stick': '']">
    <div class="zlr-progress-in"
         :class="[typeColor ===1?'zlr-progress-green':'']"
         :style="{width: Math.floor(percent)+'%'}"></div>
  </div>
</template>

<script>
// less
import './progress.less'
export default {
  name: 'zlr-progress',
  components: {},
  props: {
    stick: {
      type: [Boolean],
      default: false
    },
    percent: {
      type: [Number],
      default: 0
    },
    typeColor: {
      type: [Number],
      default: 0
    }
  },
  data () {
    return {
      offsetTop: 0,
      isStick: false
    }
  },
  computed: {},
  mounted () {
    if (this.stick) {
      this.offsetTop = this.$refs.progress.offsetTop
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let offsetTop = this.offsetTop
      this.isStick = scrollTop > offsetTop
    }
  },
  beforeDestroy () {
    if (this.stick) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
